const MuiInputBase = {
  styleOverrides: {
    root: {
      '& .MuiInputBase-inputAdornedStart.MuiInputBase-inputAdornedEnd': {
        paddingRight: '0'
      }
    },
    inputMultiline: {
      '&.MuiOutlinedInput-input': {
        padding: '12px'
      }
    }
  }
};
export default MuiInputBase;